const Home = () => {
  return (
    <div>
      <h1>Home</h1>
      <p>Home page content</p>
    </div>
  );
};

export default Home;
